/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Column_InterviewInputs */

const en_admin_user_detail_column_interview = /** @type {(inputs: Admin_User_Detail_Column_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview`)
};

const de_admin_user_detail_column_interview = /** @type {(inputs: Admin_User_Detail_Column_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch`)
};

/**
* | output |
* | --- |
* | "Interview" |
*
* @param {Admin_User_Detail_Column_InterviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_column_interview = /** @type {((inputs?: Admin_User_Detail_Column_InterviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Column_InterviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_column_interview(inputs)
	return en_admin_user_detail_column_interview(inputs)
});